import {
  MonitoringErrorBoundary,
  MonitoringManager,
} from '@flash-tecnologia/hros-web-utility';
import { MonitoringLevel } from '@flash-tecnologia/hros-web-utility/dist/monitoring/MonitoringLevel';

export const projectDsn =
  'https://fd57e39d9b6c4222ad17c2ed3dbb2bc7@o266934.ingest.sentry.io/4505489345675264';

export class ErrorBoundary extends MonitoringErrorBoundary {
  project: string = projectDsn;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(props: any) {
    super(props);
  }

  static captureException(
    error: Error,
    severity?: MonitoringLevel,
    extras?: Record<string, unknown>,
  ) {
    MonitoringManager.captureException(projectDsn, error, severity, extras);
  }

  componentDidCatch(error: Error) {
    MonitoringManager.captureException(this.project, error);
  }
}
